/**
 * Numbering follows the boxes on the ICS 209-CG form, as printed by
 * `services/coms/src/routes/Forms/ICS_CG/forms/ICS209CG.ts`.
 *
 * Boxes 1-4 are read-only on the card; 5-9, 11-14 and 16-17 are editable. Boxes
 * 10, 15 and 18 are the same signature reprinted once per page, so the card
 * shows it once under a label naming all three.
 *
 * Box 9 splits on the printed form into 9a, notable items, and 9b, responder
 * status, which the card renders as two sections under one number.
 */
export const ICS209_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  dateTimeOfReport: '3. Date / Time of Report:',
  operationalPeriodCovered: '4. Operational Period Covered:',
  reportVersion: '5. Report Version:',
  incidentType: '6. Type of Incident:',
  situationSummary: '7. Situation Summary:',
  commandPriorities: '8. Command Priorities:',
  notableItems: '9a. Operational Reporting: Notable Items',
  responderStatus: '9b. Operational Reporting: Responder Status',
  lifeSafetyHealthIssues: '11. Life, Safety, and Health Issues:',
  marineTransportationSystem:
    '12. Impacts to Marine Transportation System and Critical Infrastructure:',
  criticalResourceRequests: '13. Critical Resource Requests and Unmet Needs:',
  plannedActions: '14. Planned Actions for Next Operational Period:',
  assignedResources: '16. Assigned Resources:',
  mediaPhotosPublicOutreach: '17. Media, Photos, and Public Outreach:',
  preparedBy: '10, 15 & 18. Prepared by:',
} as const;

export const ICS209_INCIDENT_NAME_HINT =
  'This box is read-only. It is filled from the incident name.';

/** Mirrors `resolveOperationalPeriodValues`, which the PDF export uses. */
export const ICS209_INCIDENT_LOCATION_HINT =
  'This box is read-only. It is filled from the incident location, falling back to the address set when the incident was created.';

export const ICS209_DATE_TIME_OF_REPORT_HINT =
  'This box is read-only. It is filled from when this status summary was created.';

/**
 * Box 4 holds the next operational period rather than the current one, which
 * `fetchFormInputsForICS209CG` resolves through
 * `getNextOperationalPeriodByIncidentId`.
 */
export const ICS209_OPERATIONAL_PERIOD_HINT =
  'This box is read-only. It covers the next operational period, which the report looks ahead to.';
